import { defineMessages } from "react-intl";

const messages = defineMessages({
  errorLoadingRequisitionLists: {
    id: "modules.RequisitionList.AddToRequisitionList.errorLoadingRequisitionLists",
    defaultMessage: "There was an error while loading the requisition lists",
  },
  addToARequisitionList: {
    id: "modules.RequisitionList.AddToRequisitionList.addToARequisitionList",
    defaultMessage: "Add to a requisition list",
  },
  notAllOptionsSet: {
    id: "modules.RequisitionList.AddToRequisitionList.notAllOptionsSet",
    defaultMessage: "Not all options set",
  },
  addToANewREquisitionList: {
    id: "modules.RequisitionList.AddToRequisitionList.addToANewRequisitionList",
    defaultMessage: "Add to a new requisition list",
  },
});

export default messages;
